interface ICustom {
  avatar: {
    url: string
    default_url: string
  }
  logo: {
    url: string
    default_url: string
  }
}

export function useCustomSetting() {
  return useState<ICustom>('logoModel', () => ({
    avatar: {
      url: '',
      default_url: '',
    },
    logo: {
      url: '',
      default_url: '',
    },
  }))
}

const CustomSettingService = {
  defaultAvatar() {
    const customImgModel = useCustomSetting()
    return customImgModel.value.avatar.default_url
  },
  defaultLogo() {
    const customImgModel = useCustomSetting()
    return customImgModel.value.logo.default_url
  },
  setAvatar(url: string) {
    const customImgModel = useCustomSetting()
    customImgModel.value.avatar.url = url
  },
  setAvatarDefault(url: string) {
    const customImgModel = useCustomSetting()
    customImgModel.value.avatar.default_url = url
  },
  resetAvatar() {
    const customImgModel = useCustomSetting()
    customImgModel.value.avatar.url = customImgModel.value.avatar.default_url
  },
  setLogo(url: string) {
    const customImgModel = useCustomSetting()
    customImgModel.value.logo.url = url
  },
  setLogoDefault(url: string) {
    const customImgModel = useCustomSetting()
    customImgModel.value.logo.default_url = url
  },
  resetLogo() {
    const customImgModel = useCustomSetting()
    customImgModel.value.logo.url = customImgModel.value.logo.default_url
  },
}

export const CustomSettingApp = {
  get defaultAvatar() {
    return CustomSettingService.defaultAvatar()
  },
  get defaultLogo() {
    return CustomSettingService.defaultLogo()
  },
  initAvatar(url: string, default_url: string) {
    CustomSettingService.setAvatar(url)
    CustomSettingService.setAvatarDefault(default_url)
  },
  initLogo(url: string, default_url: string) {
    CustomSettingService.setLogo(url)
    CustomSettingService.setLogoDefault(default_url)
  },
  setAvatar(url?: string) {
    if (url) {
      CustomSettingService.setAvatar(url)
    } else {
      CustomSettingService.resetAvatar()
    }
  },
  setLogo(url?: string) {
    if (url) {
      CustomSettingService.setLogo(url)
    } else {
      CustomSettingService.resetLogo()
    }
  },
}
